import {
  FaAnglesUp,
  FaAngleUp,
  FaArrowRightArrowLeft,
  FaBook,
  FaCakeCandles,
  FaCalendarCheck,
  FaChartBar,
  FaChartSimple,
  FaCircleLeft,
  FaCircleRight,
  FaCodePullRequest,
  FaDollarSign,
  FaFaceSmile,
  FaGift,
  FaHouse,
  FaPercent,
  FaPlaneDeparture,
  FaReceipt,
  FaSquareCheck,
  FaTicketSimple,
} from "react-icons/fa6";

const MenuBC = [
  {
    label: "Home",
    to: "",
    icon: <FaHouse />,
  },
  {
    label: "Transaction",
    type: "menu-title",
  },
  {
    label: "Appointment",
    to: "transaction/appointment",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Customer Data",
    to: "transaction/customerdata",
    icon: <FaFaceSmile />,
  },
  {
    label: "Price List",
    to: "transaction/price-list",
    icon: <FaDollarSign />,
  },
  {
    label: "Birthday",
    to: "transaction/birthday",
    icon: <FaCakeCandles />,
  },
  {
    label: "Follow Up",
    to: "transaction/follow-up",
    icon: <FaSquareCheck />,
  },
  {
    label: "Vacation",
    to: "employee/vacation",
    icon: <FaPlaneDeparture />,
  },
  {
    label: "Customer",
    type: "menu-title",
  },
  {
    label: "Request Expired Date",
    to: "customer/request-expired-date",
    icon: <FaAnglesUp />,
  },
  {
    label: "Package Request",
    to: "customer/package-request",
    icon: <FaCodePullRequest />,
  },
  {
    label: "Customer Voucher",
    to: "customer/vouchers",
    icon: <FaTicketSimple />,
  },
  {
    label: "Customer Discount",
    to: "customer/discounts",
    icon: <FaPercent />,
  },
  {
    label: "Report",
    type: "menu-title",
  },
  {
    label: "Report",
    to: "report",
    icon: <FaChartBar />,
  },
  {
    label: "Report Voucher",
    to: "report/customer-voucher",
    icon: <FaTicketSimple />,
  },
  {
    label: "Report Discount",
    to: "report/customer-discount",
    icon: <FaPercent />,
  },
  {
    label: "Report Free Product",
    to: "report/customer-free-product",
    icon: <FaGift />,
  },
  {
    label: "Report Point",
    to: "report/customer-point",
    icon: <FaChartSimple />,
  },
  {
    label: "Utilities",
    type: "menu-title",
  },
];

export default MenuBC;
